// Where a settlement card stands: "owed", "settled" or "over" (paid more than
// owed, a credit). Decided once, here, for the Settled badge, the big figure
// and the colours: amber only while money is owed or a credit is waiting.
// (ZEN-810)
export function settlementState(c) {
  const net = Number(c?.net) || 0;
  if (net > 0.005) return "owed";
  if (net < -0.005) return "over";
  return "settled";
}
